<template>
  <div class="mt-10">
    <div class="mb-4">
      <h3 class="fsize32 text-primary font-semibold mb-2">Nutrition</h3>
      <p class="fsize14">
        Nutrition plays a critical role in cancer treatment, and as a caregiver,
        it's essential to understand how to support the patient's nutritional
        needs. In this blog, we will discuss the importance of nutrition for
        cancer patients and ways to help them maintain a healthy diet.
      </p>
    </div>
    <div class="flex w-full gap-6">
      <div class="container">
        <div class="w-full mt-8">
          <h2 class="fsize20 text4F0A4B text-left mb-4 uppercase">
            Why <b>nutrition is essential</b> for cancer patients ?
          </h2>
          <div class="cust-sections mb-3">
            <p class="fsize14">
              <span class="fsize13 font-semibold uppercase"
                >Maintaining strength and energy:</span
              >
              Cancer treatment can be physically draining, and good nutrition is
              necessary to maintain strength and energy levels. 
            </p>
          </div>

          <div class="cust-sections mb-3">
            <p class="fsize14">
              <span class="fsize13 font-semibold uppercase"
                >Promoting healing and recovery:</span
              >
              Adequate nutrition is crucial to help the patient's body recover
              from cancer treatment and manage side effects.
            </p>
          </div>

          <div class="cust-sections mb-3">
            <p class="fsize14">
              <span class="fsize13 font-semibold uppercase"
                >Boosting the immune system:</span
              >
              Proper nutrition can help boost the patient's immune system,
              reducing the risk of infections and complications.
            </p>
          </div>
          <div class="cust-sections">
            <p class="fsize14">
              <span class="fsize13 font-semibold uppercase"
                >Improving quality of life:</span
              >
              Good nutrition can help improve the patient's quality of life by
              managing symptoms and side effects of treatment.
            </p>
          </div>
        </div>

        <div class="mt-8">
          <div class="w-full">
            <h2 class="fsize20 text4F0A4B text-left mb-1 uppercase">
              Tips for maintaining <b>a healthy diet</b> ?
            </h2>
          </div>
          <div class="w-full grid grid-cols-5 gap-4 mt-8">
            <div>
              <img
                src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/cancer-page/Variety-Food.jpg"
                alt="cancer"
                class="section_image1 object-cover"
              />
              <h2
                class="fsize16 text4F0A4B text-center mt-6 capitalize font-semibold"
              >
                Eat a Variety of <br />
                Foods
              </h2>
              <p class="fsize13 mt-2 text-center">
                Encourage the patient to eat a variety of fruits, vegetables,
                whole grains, lean proteins, and healthy fats to get all the
                nutrients they need.
              </p>
            </div>
            <div>
              <img
                src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/cancer-page/Stay-Hydrated.jpg"
                alt="cancer"
                class="section_img2 object-cover"
              />
              <h2
                class="fsize16 text4F0A4B text-center mt-6 capitalize font-semibold"
              >
                Stay <br />
                Hydrated
              </h2>
              <p class="fsize13 mt-2 text-center">
                It's essential to stay hydrated during cancer treatment.
                Encourage the patient to drink plenty of water and other fluids
                throughout the day.
              </p>
            </div>
            <div>
              <img
                src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/cancer-page/Manage-Side-effects.jpg"
                alt="cancer"
                class="section_img3 object-cover"
              />
              <h2
                class="fsize16 text4F0A4B text-center mt-6 capitalize font-semibold"
              >
                Manage Side <br />
                Effects
              </h2>
              <p class="fsize13 mt-2 text-center">
                Some cancer treatments can cause side effects that affect
                appetite, taste, and digestion. Work with the patient's
                healthcare team to manage these symptoms and find foods that the
                patient can tolerate.
              </p>
            </div>
            <div>
              <img
                src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/cancer-page/Monitor-weight.jpg"
                alt="cancer"
                class="section_img4 object-cover"
              />
              <h2
                class="fsize16 text4F0A4B text-center mt-6 capitalize font-semibold"
              >
                Monitor <br />
                Weight
              </h2>
              <p class="fsize13 mt-2 text-center">
                Cancer treatment can cause weight loss or gain. Monitoring
                weight and adjusting the patient's diet as needed can help
                maintain a healthy weight.
              </p>
            </div>
            <div>
              <img
                src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/cancer-page/Discuss-supplements.jpg"
                alt="cancer"
                class="section_img4 object-cover"
              />
              <h2
                class="fsize16 text4F0A4B text-center mt-6 capitalize font-semibold"
              >
                Discuss <br />
                Supplements
              </h2>
              <p class="fsize13 mt-2 text-center">
                Some cancer patients may need nutritional supplements to meet
                their dietary needs. Discuss with the patient's healthcare team
                if supplements are necessary. 
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="w-1/6 border-left py-4 pl-4">
        <div class="border-bottom">
          <h2 class="fsize16 font-semibold pb-1">Our Latest Blogs</h2>
          <p class="fsize13 lh16px pb-2 clr-0087d4">
            5 Essential Tips for Balancing Caregiving and Self-Care
          </p>
          <p class="fsize13 lh16px pb-2 clr-0087d4">
            Navigating the Emotional Challenges of Being a...
          </p>
          <p class="fsize13 lh16px pb-2 clr-0087d4">
            How to Create a Support Network for Caregivers
          </p>
          <p class="fsize13 lh16px pb-2 clr-0087d4">
            Understanding the Legal Rights of Family Caregivers
          </p>
          <p class="fsize13 lh16px pb-3 clr-0087d4">
            10 Signs of Caregiver Burnout and How to Avoid It
          </p>
        </div>
        <div class="border-bottom py-3">
          <h2 class="fsize16 font-semibold pb-1">Latest Research</h2>
          <p class="fsize13 lh16px pb-2 clr-0087d4">
            The Mental Health Impact of Caregiving on Family Members
          </p>
          <p class="fsize13 lh16px pb-2 clr-0087d4">
            Emerging Trends in Palliative Care: What Caregivers Need ..
          </p>
          <p class="fsize13 lh16px pb-2 clr-0087d4">
            he Science Behind Compassion Fatigue: What...
          </p>
          <p class="fsize13 lh16px pb-2 clr-0087d4">
            Latest Research on the Emotional Toll of End-of-Life..
          </p>
          <p class="fsize13 lh16px pb-3 clr-0087d4">
            Emerging Trends in Palliative Care: What Caregivers...
          </p>
        </div>
        <div class="border-bottom py-3">
          <h2 class="fsize16 font-semibold pb-1">Explore Resources</h2>
          <p class="fsize13 lh16px pb-2 clr-0087d4">Emotional First Aid</p>
          <p class="fsize13 lh16px pb-2 clr-0087d4">Caregiver Coach Program</p>
          <p class="fsize13 lh16px pb-2 clr-0087d4">Mental health Awareness</p>
          <p class="fsize13 lh16px pb-2 clr-0087d4">Medical Terminology</p>
          <p class="fsize13 lh16px pb-3 clr-0087d4">Caring at Caregiver sath</p>
        </div>
        <div class="border-bottom py-3">
          <h2 class="fsize16 font-semibold pb-1">
            Helpful Links and Collaborations
          </h2>
          <p class="fsize13 lh16px pb-2 clr-0087d4">
            Duis volutpat pulvinar nisi
          </p>
          <p class="fsize13 lh16px pb-2 clr-0087d4">
            et rutrum nisl rhoncus nec
          </p>
        </div>
      </div>/// -->
      <!-- <div class="border-left lg:w-2/12 md:w-2/12 w-full lg:mt-0 md:mt-0 mt-4">
        <SideBlogs />
      </div> -->
    </div>
  </div>
</template>

<script>
import SideBlogs from "./components/SideBlogs.vue";

export default {
  components: {
    SideBlogs,
  },
};
</script>
<style>
.cust-sections {
  background-color: #cceff2;
  padding: 10px 75px;
  color: #000;
  border-radius: 8px;
  text-align: center;
  font-size: 14px;
}
.section_image1 {
  border-radius: 60px 0px 60px 60px;
  height: 175px;
  box-shadow: 3.08px 3.08px 10.79px 0px #0000003d;
}
.section_img2 {
  border-radius: 60px 0px 60px 60px;
  height: 175px;
  box-shadow: 3.08px 3.08px 10.79px 0px #0000003d;
}
.section_img3 {
  border-radius: 60px 0px 60px 60px;
  height: 175px;
  box-shadow: 3.08px 3.08px 10.79px 0px #0000003d;
}
.section_img4 {
  border-radius: 0px 60px 60px 60px;
  height: 175px;
  box-shadow: 3.08px 3.08px 10.79px 0px #0000003d;
}
.section_img5 {
  border-radius: 0px 60px 60px 60px;
  height: 175px;
  box-shadow: 3.08px 3.08px 10.79px 0px #0000003d;
}
</style>
